import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=7f3f6be4&"
import script from "./projects.vue?vue&type=script&lang=js&"
export * from "./projects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports